// extracted by mini-css-extract-plugin
export default {"menu":"ActionsPopup_menu__PEo2X","menuItem":"ActionsPopup_menuItem__Ewinj"};